import * as React from 'react'
import { ReadAllButtonConnected } from './ReadAllButtonConnected'
import { Provider } from 'react-redux'
import { mockState, createMockStore } from 'mockState'

export const ReadAllButtonExamples = () => {
  return (
    <div className="ReadAllButtonExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <ReadAllButtonConnected notificationGroup="messages" />
      </Provider>
    </div>
  )
}
